export const DLL_PAGE_DESCRIPTION = `Prepare up to 5 days worth of lesson logs in one go! Each concise daily lesson log is packaged in a table with procedures pre-filled and formatted according to 
DepEd Order No. 42, s. 2016.`;

export const DLL_CURRICULUM_REFERENCE =
  'https://www.deped.gov.ph/wp-content/uploads/2016/06/DO_s2016_042.pdf#page=22';
